import {getUserSession} from './Session';

class Fetch {
    post(url = ``, data = {}) {
        const session = getUserSession();
        if(!data.token){
            if(session){
                data.token = session.token;
            }   
        }
        return fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
            body: JSON.stringify(data), // body data type must match "Content-Type" header
        })
        .then(response => {
            return response.json().then(data => {
                if(data.access_denied == true){
                    localStorage.removeItem('session');
                    window.location.assign('/login');
                    
                } else {
                    return data;
                }
            });
        }); // parses response to JSON
    }

    put(url = ``, data = {}) {
        const session = getUserSession();
        if(!data.token){
            if(session){
                data.token = session.token;
            }   
        }
        return fetch(url, {
            method: "PUT", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
            body: JSON.stringify(data), // body data type must match "Content-Type" header
        })
        .then(response => {
            return response.json().then(data => {
                if(data.access_denied == true){
                    localStorage.removeItem('token');
                    window.location.assign('/login');
                } else {
                    return data;
                }
            });
        });
    }

    putBlob(url = ``, data = {}) {
        const session = getUserSession();
        if (!data.token) {
            if (session) {
                data.token = session.token;
            }
        }
        return fetch(url, {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            redirect: "follow",
            referrer: "no-referrer",
            body: JSON.stringify(data),
        })
        .then(response => {
            const contentType = response.headers.get('Content-Type') || '';
            if (contentType.includes('application/json')) {
                return response.json().then(data => {
                    if (data.access_denied == true) {
                        localStorage.removeItem('token');
                        window.location.assign('/login');
                    } else {
                        throw new Error(data.message || 'Erro ao gerar arquivo');
                    }
                });
            }
            return response.blob();
        });
    }

    delete(url = ``, data = {}) {
        const session = getUserSession();
        if(!data.token){
            if(session){
                data.token = session.token;
            }   
        }
        return fetch(url, {
            method: "DELETE", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
            body: JSON.stringify(data), // body data type must match "Content-Type" header
        })
        .then(response => {
            return response.json().then(data => {
                if(data.access_denied == true){
                    localStorage.removeItem('token');
                    window.location.assign('/login');
                } else {
                    return data;
                }
            });
        });
    }   

    get(url = ``) {
        const session = getUserSession();
        return fetch(url, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
        })
        .then(response => {
            return response.json().then(data => {
                if(data.access_denied == true){
                    localStorage.removeItem('token');
                    window.location.assign('/login');
                } else {
                    return data;
                }
            });
        });
    }
}

export default new Fetch();
